export const createRerenderNode = () => {
    let renderScheduled = true;
    let rerender = null;

    return {
        markForRerender: () => {
            renderScheduled = true;
        },

        isRenderScheduled: () => {
            // console.log("isRenderScheduled", renderScheduled, index);
            return renderScheduled;
        },

        renderDone: () => {
            // console.log("renderDone", index);
            renderScheduled = false;
        },
        setRerenderer: (rerender1) => rerender = rerender1,

        scheduleRender: () => {
            if (!renderScheduled) {
                renderScheduled = true;
                rerender.forceUpdate();
            }
            return null;
        },

    };
};
